import { TopbarExtensionComponent } from "./topbarExtension";

export const TopbarExtension = TopbarExtensionComponent;
